import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const assessmentMeasurement = {
  version: 0,
  title: 'AssessmentMeasurement',
  primaryKey: 'rowId',
  type: 'object',
  properties: {
    rowId: {
      maxLength: 36,
      type: 'string',
    },
    updatedAt: {
      type: 'string',
    },
    assessmentId: {
      ref: 'assessment',
      type: 'string',
    },
    organization: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    mobility: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    mentalHealth: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    physicalHealth: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    selfSufficiency: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    socialContacts: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    livingEnvironment: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    careRelationship: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
    relativeSituation: {
      type: ['object', 'null'],
      properties: {
        arrayValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['array', 'null'],
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
        stringValues: {
          type: ['array', 'null'],
          items: {
            type: 'object',
            properties: {
              fieldName: {
                type: ['string', 'null'],
              },
              value: {
                type: ['string', 'null'],
              },
            },
          },
        },
      },
    },
  },
  required: ['rowId', 'updatedAt', 'assessmentId'],
} as const

const schemaTyped = toTypedRxJsonSchema(assessmentMeasurement)

export type AssessmentMeasurement = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>

export const assessmentMeasurementSchema: RxJsonSchema<AssessmentMeasurement> =
  assessmentMeasurement
